var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOthrTextWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.332,
    height: 18.301,
    viewBox: "0 0 47.332 18.301",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2708",
    "data-name": "Groupe 2708",
    transform: "translate(-129.021 -40)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1947",
    "data-name": "Trac\\xE9 1947",
    d: "M51.948,9.5a6.009,6.009,0,0,0-.4-2.252,4.927,4.927,0,0,0-1.2-1.781,5.125,5.125,0,0,0-1.819-1.091A6.829,6.829,0,0,0,46.4,4.026a6.7,6.7,0,0,0-2.013.307c-.063.019-.125.044-.188.069l-.376.138V1.706A1.745,1.745,0,0,0,42.038,0h-.006A1.749,1.749,0,0,0,40.32,1.718V16.582a1.736,1.736,0,0,0,.552,1.223,1.7,1.7,0,0,0,1.185.483h.05A1.749,1.749,0,0,0,43.82,16.57V10.555a4.435,4.435,0,0,1,.194-1.317,2.852,2.852,0,0,1,.508-.966,2.28,2.28,0,0,1,.765-.6,2.525,2.525,0,0,1,1.029-.22H46.4a3.078,3.078,0,0,1,.9.138,1.491,1.491,0,0,1,.972.9,2.874,2.874,0,0,1,.169,1.085v7.024a1.75,1.75,0,0,0,3.5-.013V9.5Z",
    transform: "translate(113.988 40)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1948",
    "data-name": "Trac\\xE9 1948",
    d: "M69.713,8.252A2.041,2.041,0,0,0,68.339,7.7h-.113a7.422,7.422,0,0,0-1.888.307,7.178,7.178,0,0,0-1.279.539l-.182.1L64.733,8.5a1.808,1.808,0,0,0-1.254-.514A1.765,1.765,0,0,0,61.71,9.707v9.734a1.767,1.767,0,0,0,1.762,1.718,1.773,1.773,0,0,0,1.762-1.725V14.894a5.351,5.351,0,0,1,.238-1.574,3.343,3.343,0,0,1,.646-1.2,2.866,2.866,0,0,1,1.047-.765,3.461,3.461,0,0,1,1.261-.238,2.89,2.89,0,0,1,.326.013h.069a1.571,1.571,0,0,0,1.047-.4,1.463,1.463,0,0,0,.47-1.066,1.91,1.91,0,0,0-.621-1.4Z",
    transform: "translate(106.013 37.129)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1949",
    "data-name": "Trac\\xE9 1949",
    d: "M6.905,7.98a6.646,6.646,0,1,0-.038,13.283A6.646,6.646,0,1,0,6.905,7.98Zm-.038,2.772a3.747,3.747,0,0,1,3.7,3.87v.038a3.669,3.669,0,0,1-3.663,3.832,3.724,3.724,0,0,1-3.681-3.87,3.7,3.7,0,0,1,3.644-3.87Z",
    transform: "translate(129.021 37.025)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1950",
    "data-name": "Trac\\xE9 1950",
    d: "M30.891,5.024H28.332V1.964a1.747,1.747,0,0,0-3.493,0V5.024H23.766a1.706,1.706,0,1,0,0,3.412h1.072v8.191a1.747,1.747,0,0,0,3.493,0V8.436h2.559a1.706,1.706,0,0,0,0-3.412Z",
    transform: "translate(120.796 39.918)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOthrTextWhite);
export default __webpack_public_path__ + "static/media/OthrTextWhite.e6d1708686166570b7acdd1a87778a27.svg";
export { ForwardRef as ReactComponent };